import { render, staticRenderFns } from "./ClientPermissionsForm.vue?vue&type=template&id=78e1fc1a"
import script from "./ClientPermissionsForm.vue?vue&type=script&lang=js"
export * from "./ClientPermissionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports